<template>
  <div class="mandati">

    <gnetHeader v-bind:logo="$store.state.logoimage"></gnetHeader>

    <gnetTabBar
      v-bind:titoloapp="'Portale Clienti'"
      v-bind:tabs="$store.state.tabs"
      v-bind:active_tab="$store.state.active_tab"
      v-on:click="changeTab($event)"
    />

    <div class="slds-grid">
      <div v-bind:class="{ 'slds-col slds-size_2-of-3': showTimeline, 'slds-col slds-size_11-of-12': !showTimeline }">

        <gnetTabs v-bind:tabs="$store.state.campagne" v-on:change="changeCampagnaOrdini($event)" v-bind:multi="false" v-bind:multidefault="filtrocampagneO">
          <template v-slot:main>

            <div class="pippo slds-scrollable">
              <table class="slds-table slds-table_cell-buffer slds-table_bordered slds-table_col-bordered slds-table_striped">

                <thead>
                  <tr class="slds-line-height_reset">
                    <th v-for="(col, index) in colsfoto" v-bind:key="col.order" style="vertical-align:top" v-on:click="$emit('filter',index)" >
                      <span class="pippo"  >{{$t(col.label)}}</span>

                      <svg v-if="col.filtered" class="slds-icon slds-icon-text-default slds-icon_x-small" aria-hidden="true">
                        <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#filterList"></use>
                      </svg>
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-on:click="$emit('row',rindex)" v-for="(record, rindex) in foto" v-bind:key="record.id" class="slds-hint-parent">

                    <td v-for="(col,index) in colsfoto" v-bind:key="col.order" v-bind:style="'text-align:'+align(col.type)" class="slds-truncate">

                      <a v-if="index==0" v-bind:href="record['data']"  v-bind:download="record['name']" v-bind:id="record['Id']" v-on:click="scaricaFile(rindex)">
                        <div class="slds-truncate"  >
                          {{getFieldValue(record,col.name) | filter(col.type) }}
                        </div>
                      </a>

                      <span v-if="index>0" class="slds-truncate">

                        <span v-if="col.type=='alert' && record[col.name]" class="slds-icon_container slds-icon-utility-announcement" v-bind:title="$t('Alert')">
                          <svg class="slds-icon slds-icon-text-default slds-icon_x-small" aria-hidden="true">
                            <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#alert"></use>
                          </svg>
                          <span class="slds-assistive-text">Alert</span>
                        </span>
                        
                        {{getFieldValue(record,col.name) | filter(col.type) }}
                        
                      </span>

                    </td>

                  </tr>
                </tbody>
              </table>
            </div>

          </template>
        </gnetTabs>
        <a v-show="false" v-bind:href="csvdata" v-bind:download="'prodotti.csv'" id="downloadcsv">Scarica CSV</a>

      </div>

    </div>

    <gnetSpinner v-bind:busy="busy"></gnetSpinner>
    <modal v-if="showDownload" v-bind:savetext="'Chiudi'" v-bind:canceltext="'Annulla'" v-bind:wmode="false" v-bind:title="'Download in corso'" v-bind:hspace="'small'" v-on:submit="showDownload=false" v-on:cancel="showDownload=false">
      {{messaggiodownload}}
      <span v-if="datidownload.spinner" class="slds-icon-eq slds-is-animated" title="scansione antivirus">
        <div class="slds-icon-eq__bar"></div>
        <div class="slds-icon-eq__bar"></div>
        <div class="slds-icon-eq__bar"></div>
        <span class="slds-assistive-text">scansione antivirus</span>
      </span>
      <a id="downloadfile" v-if="datidownload.completato" v-bind:href="datidownload.data"  v-bind:download="datidownload.filename" style="display:none" >
        Clicca qui per scaricare il file
      </a>
    </modal>

  </div>
</template>

<script>

// @ is an alias to /src
// import numeral from 'numeral'
import gnetHeader from '../components/header.vue'
import gnetTabBar from '../components/tabbar.vue'
import gnetSpinner from '../components/spinner.vue'
import gnetTabs from '../components/tabs.vue'
import apiclient from '@/apiclient.js'
import gnetMixLib from '@/mixin.js'
import modal from '../components/modal.vue'
import moment from 'moment'
import numeral from 'numeral'

export default {
  name: 'Linee',
  mixins: [gnetMixLib],
  components: {
    gnetHeader,
    gnetTabBar,
    gnetTabs,
    gnetSpinner,
    modal
  },
  filters: {
    filter: function(v, type) {
      switch(type) {
        case 'date':
          if (v) {
            var n=new moment(v);
            return n.format('DD/MM/YYYY');
          }
          return v;
        case 'decimal':
          if (v)
            return numeral(v).format('0,0');
          return v;
        case 'currency':
          if (v)
            return numeral(v).format('$ 0,0.00');
          return v;
        case 'dimension':
          if (v)
            return numeral(v).format('0,0');
          return v;
        case 'alert':
            if (!v)
              return '';
            return '';
        case 'truncate':
          if (v)
            return v.substr(0,32);
      }
      return v;
    }
  },
  data: function() {
    return {
      showDownload: false,
      datidownload: {id: '', data:'', status:'', filename:'', completato:false, spinner:true },
      messaggiodownload:'scansione antivirus in corso...',
      colsfoto:[
        { order: 1, value:'', label:'Nome file', name:'name', type:'string' },
        { order: 2, value:'', label:'Dimensione', name:'size', type:'dimension' },
      ],
      foto:[],
      imgname:'',
      imgdata:'',
      csvdata:'',
      downloadready:false,
      
      showpdfordini: false,
      showpdf: false,
      showpdfnolinee: false,
      showTimeline: false,
      listordini: true,
      listfatture: false,
      listcredito: false,
      listdocumenti: false,

      listmode: true,

      busy: false,
      recordId:this.$store.getters.connection.userdata.AccountId,
      record: {},
      create:false,

      filtrocampagneO:[false,true,false,false,false,false],
      filtrocampagneF:[false,false,false,false,false,false],
      ticketfields:[],
      ticketLastCreated:'',

      tickets:[],
      tasks:[],

      campagna:'',

      linee:[],

      ordinicols:[],
      ordini:[],

      partitecols:[],
      partite:[],
      campipartite:[],

      documenticols:[],
      documenti:[],
      ordiniCompleti:[],
      fattureComplete:[],

      fatturecols:[],
      fatture:[],
      campifatture:[],

      ordinidetailcols:[],
      ordinidetail:[],
      campiordinidetail:[],

      fields:[],
      fieldsstring: '',
      headlineFields: [],
      documentiActions: [  ],
      ordiniActions: [ {title: 'Scarica CSV', name:'scaricacsv', symbol:'download', id:'scaricacsvid' },  ],
      fattureActions: [ {title: 'Genera Pdf No Linee', name:'generapdfnolinee', symbol:'task'}, {title: 'Genera Pdf', name:'generapdf', symbol:'task'}, ],
      headlineActions: [ {title: 'NikePad', name:'nikepad', symbol:''}, {title:'Dati', name:'liste', symbol:''}, {title: 'Assegni', name:'assegni', symbol:''}, {title:'Qualifica', name:'qualifica', symbol:''} ],
      timelineActions: [ {title: 'Nuovo Ticket', name:'ticket', symbol:''}, {name:'newtask', symbol:'', title:'Nuova Attività'}],
      sections:[],

      timeline: [],

      editTask: false,
      showAssegni: false,
      editTicket:false,
      showQualifica:false,

      csvbuf:'',

      dati: {
        Name:'',
        Codice_Subentro__c:'',
        Insegna__c:'',

        BillingStreet:'',
        BillingCity:'',
        BillingPostalcode:'',
        BillingState:'',

        Referente__c:'',
        Phone:'',
        Fax:'',
        Email__c:'',

        P_Iva__c:'',
        IBAN__c:'',
        Codice_Fatturazione_Elettronica__c:'',
        PEC__c:'',

        Spedire__c:'',
        ShippingStreet:'',
        ShippingCity:'',
        ShippingPostalcode:'',
        ShippingState:'',

        Referente_Consegne__c:'',
        Orari__c:'',

        Tipologia__c:'',
        Ubicazione__c:'',
        Contratto__c:'',
        Competitors__c:'',
        Description:'',
      }

    };
  },
  watch: {
  },
  mounted: function() {

    if (!this.campagna) this.campagna=this.$store.state.campagne[0];
    this.loadLinee(1);
  },
  computed: {
    title: function() {
        if (this.record) 
          return this.record.Ragione_Sociale__c; // +' | '+this.record.Codice_2019__c;
        return '';
    },
    annocampagna: function() {
      return this.campagna.substr(0,4);
    },
    tipocampagna: function() {
      return this.campagna.substr(5,2);
    }
  },
  methods: {
    scaricaFile: function(index) {
      console.log(index);

      // if (this.foto[index].size>50000000) return;

      this.showDownload=true;
      this.messaggiodownload='scansione antivirus in corso...',

      this.datidownload.id=this.foto[index].id;
      this.datidownload.data='';
      this.datidownload.status='';
      this.datidownload.filename=this.foto[index].name;      
      this.datidownload.completato=false;
      this.datidownload.spinner=true;
      this.downloadFile( this.datidownload );
    },
    downloadAll: function() {
      if (!this.downloadready) return;
      this.foto.forEach(function(f) {
        var x=document.getElementById(f.id);
        x.click();
      })
    },
    align: function(type) {
      switch(type) {
        case 'currency':
        case 'decimal':
        case 'dimension':
          return 'right';
      }
      return 'left';
    },
    hexEncode : function(str){
        var hex, i;
        var result = "";
        for (i=0; i<str.length; i++) {
            hex = str.charCodeAt(i).toString(16);
            result += ("000"+hex).slice(-4);
        }
        return result
    },
    downloadFile: function(event) {
      var self=this;
      var cb=function(status) {
        if (status.total) {
          var perc=status.loaded/status.total;
          self.messaggiodownload='donwload in corso: '+numeral(perc).format('0%');
          self.datidownload.spinner=false;
        }
      };
      console.log('richiesta di '+event.id);
      apiclient.getasset(this.$store.getters.connection, event.id, cb).then(function(data) {
        console.log('download completato')
        self.messaggiodownload='download completato';
        event.completato=true;
        event.data='data:image/png;base64,'+data.data;
        self.$nextTick(function() {
          var x=document.getElementById('downloadfile');
          x.click();
          self.showDownload=false;
        })
      });
    },
    download: function(fileId, filename, data) {

      this.imgname=filename;
      this.imgdata='data:image/png;base64,'+data;

      this.$nextTick(function() {
        var clickme=document.getElementById(fileId);
        clickme.click();
      })
    },
    changeCampagnaOrdini: function(index) {
      this.filtrocampagneO.fill(false);
      this.filtrocampagneO[index]=true;
      this.loadLinee(index);
    },
    loadLinee: function(index) {
      console.log('loadLinee')
      console.log(index)
      var self=this;
      
      var folderid='';
      if (index==0) folderid='1zFu9198jXqh32tc4KMaci8XGdmGyou8K';
      if (index==1) folderid='1zFu9198jXqh32tc4KMaci8XGdmGyou8K';
      if (index==2) folderid='1H2oW_IjCwfgx5yuLoDSIw6OMGrXh8gkP';
      if (index==3) folderid='1mF82VOQWDpkz4AnlKR8ecGRcX9Bl5Q-E';

      console.log(folderid);
      apiclient.getfolderassets(this.$store.getters.connection, folderid).then(function(data) {
        if (data.data) {
          self.foto=[];
          data.data.forEach(function(f) {
            if (f.size) {
              var foto={
                status: 'recupero file in corso',
                Id: f.id,
                id: f.id,
                name: f.name,
                size: f.size,
              };
              self.foto.push(foto);
            }
          })
        }
      });
    },
  }
}
</script>

<style scoped>
.bottonesplit {
    width: 0.75rem;
    background: white;
    border-radius: 0;
    border: 1px solid #dddbda;
}
</style>

